import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import * as App from "./../../App";

//
// Firebase READ API
//

//
// TRADEMARKS
//

export async function getTrademarks(userID: string): Promise<{ [key: string]: App.Data.App.ITrademark }> {
    const ref = firebase.database().ref(`/trademarks/${userID}`);
    const snapshot = await ref.once("value");
    const val: { [key: string]: App.Data.App.ITrademark } = snapshot.val();
    if (!val) { return val; }

    // Validate deadlines...
    Object.keys(val).forEach((key: string) => {
        if (!val[key].deadlines) { val[key].deadlines = []; }
        val[key].deadlines = App.Data.App.TrademarkUtils.validateDeadlines(val[key]);
    });

    // Update Expiration Date...
    Object.keys(val).forEach((key: string) => {
        const renewalDue = val[key].deadlines.find(x => x.title === "RENEWAL DUE");
        if (renewalDue && renewalDue.dueDate) { val[key].expirationDate = renewalDue.dueDate; }
    });

    return val;
}

export async function getTrademarkById(userID: string, trademarkID: string): Promise<App.Data.App.ITrademark> {
    const ref = firebase.database().ref(`/trademarks/${userID}/${trademarkID}`);
    const snapshot = await ref.once("value");
    const val: App.Data.App.ITrademark = snapshot.val();
    if (!val) { return val; }

    // Validate deadlines...
    if (!val.deadlines) { val.deadlines = []; }
    val.deadlines = App.Data.App.TrademarkUtils.validateDeadlines(val);

    // Update Expiration Date...
    const renewalDue = val.deadlines.find(x => x.title === "RENEWAL DUE");
    if (renewalDue && renewalDue.dueDate) { val.expirationDate = renewalDue.dueDate; }

    return val;
}

//
// PATENTS
//

export async function getPatents(userID: string): Promise<{ [key: string]: App.Data.App.IPatent }> {
    const ref = firebase.database().ref(`/patents/${userID}`);
    const snapshot = await ref.once("value");
    const val: { [key: string]: App.Data.App.IPatent } = snapshot.val();
    if (!val) { return val; }

    // Validate deadlines...
    Object.keys(val).forEach((key: string) => {
        if (!val[key].deadlines) { val[key].deadlines = []; }
        val[key].deadlines = App.Data.App.PatentUtils.validateDeadlines(val[key]);
    });

    return val;
}

export async function getPatentById(userID: string, patentID: string): Promise<App.Data.App.IPatent> {
    const ref = firebase.database().ref(`/patents/${userID}/${patentID}`);
    const snapshot = await ref.once("value");
    const val: App.Data.App.IPatent = snapshot.val();
    if (!val) { return val; }

    // Validate deadlines...
    if (!val.deadlines) { val.deadlines = []; }
    val.deadlines = App.Data.App.PatentUtils.validateDeadlines(val);

    return val;
}

//
// CLIENTS
//

export async function getClients(userID: string): Promise<{ [key: string]: App.Data.App.IClient }> {
    const ref = firebase.database().ref(`/clients/${userID}`);
    const snapshot = await ref.once("value");
    const val = snapshot.val();
    return (val) ? val : {};
}

export async function getClientById(userID: string, clientId: string): Promise<App.Data.App.IClient> {
    const ref = firebase.database().ref(`/clients/${userID}/${clientId}`);
    const snapshot = await ref.once("value");
    return snapshot.val();
}

//
// IMAGES
//

export function getImageURL(userID: string, imageID: string): string {
    return "TODO: ";
}



/**
 * Gets /users/{userID}/demographics
 * @param userID User ID
 */
export async function getUserDemographics(userID: string): Promise<App.Data.User.IUserDemographics | null> {
    const snapshot: firebase.database.DataSnapshot = await firebase.database().ref("users").child(userID).child("demographics").once("value");
    return snapshot.val() as App.Data.User.IUserDemographics | null;
}

/**
 * Gets /users/{userID}/applicatoinSettings
 * @param userID User ID
 */
export async function getUserApplicationSettings(userID: string): Promise<App.Data.User.IApplicationSettings | null> {
    const snapshot: firebase.database.DataSnapshot = await firebase.database().ref("users").child(userID).child("applicationSettings").once("value");
    return snapshot.val() as App.Data.User.IApplicationSettings | null;
}